import styled from 'styled-components';
import { Loader } from '@avangard/ui/core';

const PlatformLoader = styled(Loader)`
    width: initial;
    background-color: transparent;
`;

export { PlatformLoader };
